import React, { memo, useRef } from 'react';
import { Headline, Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import styled from 'styled-components';
import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';
import { sanitizeHtml, sanitizeText } from '../../utils/textUtils';

export const ClickableElement = styled.span`
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: fit-content;
  }
  width: 100%;
  pointer-events: auto; // Make the element clickable
`;
const StyledHeadline = styled(Headline)`
  ${({ theme }) => `
      color: ${theme.sys.color.foreground.neutral[100]};
  `};
  #anchors-allowed > a {
    all: unset;
    text-decoration: underline !important;
    cursor: pointer;
    outline: none;
  }
`;
export interface TextProps {
  readonly text: string;
}
const RichTextAnchor = memo(function RichTextAnchor({ text, ...inherited }: TextProps) {
  const anchorTag = text.includes('</a>') || text.includes('</u>');
  const textRef = useRef<HTMLSpanElement | null>(null);

  const content = anchorTag ? (
    <span id="anchors-allowed" dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />
  ) : (
    renderTextWithFootnotesReferencesV2(sanitizeText(text))
  );

  return (
    <ClickableElement ref={textRef}>
      {/* @ts-expect-error types not aligned */}
      <StyledHeadline {...inherited}>{content}</StyledHeadline>
    </ClickableElement>
  );
});

export const convertRichText = (richText: string) => {
  const sanitizedText = sanitizeText(richText);
  return renderTextWithFootnotesReferencesV2(sanitizedText);
};

const RichText = memo(function RichText({ text, ...inherited }: TextProps) {
  const textRef = useRef<HTMLSpanElement | null>(null);

  return (
    <ClickableElement ref={textRef}>
      <Text {...inherited}>{convertRichText(text)}</Text>
    </ClickableElement>
  );
});
export { RichTextAnchor, RichText };
